"use client";

import { c as _c } from "react/compiler-runtime";
import { useBlockExplorer } from "@opensea/app-kit";
import { graphql, useQuery } from "@opensea/graphql";
import { ModalFooterButton } from "@opensea/ui-kit";
import { AttachMoney } from "@opensea/ui-kit/icons";
import { useState } from "react";
import { useTranslations } from "use-intl";
import { NETWORK_ONLY_OPERATION_CONTEXT } from "../../../constants";
import { useAddress } from "../../../polychain/hooks";
import { useScheduler } from "../../../polychain/hooks/useScheduler";
import { useScheduler_actionFragment } from "../../../polychain/hooks/useScheduler.fragment";
import { FlowActions } from "../../../stores/flowStore";
import { FeesContentLayout, FeesContentLayoutError, FeesContentLayoutSkeleton, WalletStatusIndicator } from "../common";
const SetRoyaltyInfoQuery = graphql(`
    query SetRoyaltyInfoQuery(
      $address: Address!
      $collectionSlug: String!
      $feeInput: CollectionFeeInput!
    ) {
      setRoyaltyInfoActions(
        address: $address
        collectionSlug: $collectionSlug
        feeInput: $feeInput
      ) {
        actions {
          ...useScheduler_action
        }
      }
    }
  `, [useScheduler_actionFragment]);
export const SetRoyaltyInfoFlow = t0 => {
  const $ = _c(78);
  const {
    collectionSlug,
    fee
  } = t0;
  const t = useTranslations("wallet.SetRoyaltyInfoFlow");
  const address = useAddress();
  const [transactionIdentifier, setTransactionIdentifier] = useState();
  const {
    getTransactionUrl,
    getName
  } = useBlockExplorer(transactionIdentifier?.chain);
  const t1 = address ?? "";
  let t2;
  if ($[0] !== fee.basisPoints || $[1] !== fee.recipientAddress) {
    t2 = {
      address: fee.recipientAddress,
      basisPoints: fee.basisPoints
    };
    $[0] = fee.basisPoints;
    $[1] = fee.recipientAddress;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== collectionSlug || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      address: t1,
      collectionSlug,
      feeInput: t2
    };
    $[3] = collectionSlug;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = !address;
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = {
      query: SetRoyaltyInfoQuery,
      variables: t3,
      pause: t4,
      context: NETWORK_ONLY_OPERATION_CONTEXT
    };
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const [t6] = useQuery(t5);
  const {
    data,
    fetching,
    error
  } = t6;
  let t7;
  if ($[10] !== data?.setRoyaltyInfoActions.actions) {
    t7 = data?.setRoyaltyInfoActions.actions || [];
    $[10] = data?.setRoyaltyInfoActions.actions;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const actions = t7;
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = async lastResponse => {
      const tx = lastResponse;
      setTransactionIdentifier(tx.transactionIdentifier);
      FlowActions.onSuccess();
    };
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== actions) {
    t9 = {
      actions,
      onAllActionsCompleted: t8,
      autoStartEmbeddedWallet: true
    };
    $[13] = actions;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const {
    start,
    isPending,
    isLoading,
    isDone,
    error: schedulerError
  } = useScheduler(t9);
  if (fetching) {
    let t10;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <FeesContentLayoutSkeleton />;
      $[15] = t10;
    } else {
      t10 = $[15];
    }
    return t10;
  }
  if (error || !data?.setRoyaltyInfoActions.actions.length) {
    let t10;
    if ($[16] !== t) {
      t10 = t("close");
      $[16] = t;
      $[17] = t10;
    } else {
      t10 = $[17];
    }
    let t11;
    if ($[18] !== t10) {
      t11 = <ModalFooterButton onClick={FlowActions.endFlow} variant="secondary">{t10}</ModalFooterButton>;
      $[18] = t10;
      $[19] = t11;
    } else {
      t11 = $[19];
    }
    let t12;
    if ($[20] !== t) {
      t12 = t("title");
      $[20] = t;
      $[21] = t12;
    } else {
      t12 = $[21];
    }
    let t13;
    if ($[22] !== t11 || $[23] !== t12) {
      t13 = <FeesContentLayoutError footer={t11} icon={AttachMoney} title={t12} />;
      $[22] = t11;
      $[23] = t12;
      $[24] = t13;
    } else {
      t13 = $[24];
    }
    return t13;
  }
  const state = isDone ? "success" : isPending || isLoading ? "pending" : "error";
  if (state === "success") {
    let t10;
    if ($[25] !== getTransactionUrl || $[26] !== transactionIdentifier) {
      t10 = transactionIdentifier ? getTransactionUrl(transactionIdentifier.hash) : "";
      $[25] = getTransactionUrl;
      $[26] = transactionIdentifier;
      $[27] = t10;
    } else {
      t10 = $[27];
    }
    const explorerUrl = t10;
    let t11;
    if ($[28] !== collectionSlug || $[29] !== t) {
      t11 = t("successDescription", {
        collectionName: collectionSlug
      });
      $[28] = collectionSlug;
      $[29] = t;
      $[30] = t11;
    } else {
      t11 = $[30];
    }
    let t12;
    if ($[31] !== explorerUrl || $[32] !== getName || $[33] !== t) {
      t12 = explorerUrl && <ModalFooterButton href={explorerUrl} target="_blank" variant="secondary">{t("viewOnEtherscan", {
          explorerName: getName()
        })}</ModalFooterButton>;
      $[31] = explorerUrl;
      $[32] = getName;
      $[33] = t;
      $[34] = t12;
    } else {
      t12 = $[34];
    }
    let t13;
    if ($[35] !== t) {
      t13 = t("close");
      $[35] = t;
      $[36] = t13;
    } else {
      t13 = $[36];
    }
    let t14;
    if ($[37] !== t13) {
      t14 = <ModalFooterButton onClick={FlowActions.endFlow}>{t13}</ModalFooterButton>;
      $[37] = t13;
      $[38] = t14;
    } else {
      t14 = $[38];
    }
    let t15;
    if ($[39] !== t12 || $[40] !== t14) {
      t15 = <>{t12}{t14}</>;
      $[39] = t12;
      $[40] = t14;
      $[41] = t15;
    } else {
      t15 = $[41];
    }
    let t16;
    if ($[42] !== t) {
      t16 = t("successTitle");
      $[42] = t;
      $[43] = t16;
    } else {
      t16 = $[43];
    }
    let t17;
    if ($[44] !== t) {
      t17 = t("updateComplete");
      $[44] = t;
      $[45] = t17;
    } else {
      t17 = $[45];
    }
    let t18;
    if ($[46] !== t17) {
      t18 = <WalletStatusIndicator state="complete">{t17}</WalletStatusIndicator>;
      $[46] = t17;
      $[47] = t18;
    } else {
      t18 = $[47];
    }
    let t19;
    if ($[48] !== t11 || $[49] !== t15 || $[50] !== t16 || $[51] !== t18) {
      t19 = <FeesContentLayout body={t11} footer={t15} icon={AttachMoney} title={t16} walletStatus={t18} />;
      $[48] = t11;
      $[49] = t15;
      $[50] = t16;
      $[51] = t18;
      $[52] = t19;
    } else {
      t19 = $[52];
    }
    return t19;
  }
  let t10;
  if ($[53] !== t) {
    t10 = t("description");
    $[53] = t;
    $[54] = t10;
  } else {
    t10 = $[54];
  }
  let t11;
  if ($[55] !== t) {
    t11 = t("close");
    $[55] = t;
    $[56] = t11;
  } else {
    t11 = $[56];
  }
  let t12;
  if ($[57] !== t11) {
    t12 = <ModalFooterButton onClick={FlowActions.endFlow} variant="secondary">{t11}</ModalFooterButton>;
    $[57] = t11;
    $[58] = t12;
  } else {
    t12 = $[58];
  }
  let t13;
  if ($[59] !== t) {
    t13 = t("title");
    $[59] = t;
    $[60] = t13;
  } else {
    t13 = $[60];
  }
  let t14;
  if ($[61] !== isLoading || $[62] !== t) {
    t14 = isLoading && t("accepting");
    $[61] = isLoading;
    $[62] = t;
    $[63] = t14;
  } else {
    t14 = $[63];
  }
  let t15;
  if ($[64] !== isPending || $[65] !== t) {
    t15 = isPending && t("acceptInWallet");
    $[64] = isPending;
    $[65] = t;
    $[66] = t15;
  } else {
    t15 = $[66];
  }
  const t16 = schedulerError && String(schedulerError);
  let t17;
  if ($[67] !== start || $[68] !== state || $[69] !== t14 || $[70] !== t15 || $[71] !== t16) {
    t17 = <WalletStatusIndicator onClick={start} state={state}>{t14}{t15}{t16}</WalletStatusIndicator>;
    $[67] = start;
    $[68] = state;
    $[69] = t14;
    $[70] = t15;
    $[71] = t16;
    $[72] = t17;
  } else {
    t17 = $[72];
  }
  let t18;
  if ($[73] !== t10 || $[74] !== t12 || $[75] !== t13 || $[76] !== t17) {
    t18 = <FeesContentLayout body={t10} footer={t12} icon={AttachMoney} title={t13} walletStatus={t17} />;
    $[73] = t10;
    $[74] = t12;
    $[75] = t13;
    $[76] = t17;
    $[77] = t18;
  } else {
    t18 = $[77];
  }
  return t18;
};